import { render, staticRenderFns } from "./PsychOverviewScatter.vue?vue&type=template&id=1d033c37&scoped=true"
import script from "./PsychOverviewScatter.vue?vue&type=script&lang=js"
export * from "./PsychOverviewScatter.vue?vue&type=script&lang=js"
import style0 from "./PsychOverviewScatter.vue?vue&type=style&index=0&id=1d033c37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d033c37",
  null
  
)

export default component.exports